import { Component, Vue } from 'vue-property-decorator'
import Store from '@/common/utils/Store'
import SessionStorageService from '@/common/SessionStorageService'
import CommonConstants from '@/common/CommonConstants'
@Component({
  name: 'CACG0070',
  components: {}
  })
export default class CACG0070Controller extends Vue {
  /**
   * 画面要素描画後処理
   */
  mounted() {
    this.init()
  }

  /**
   * 初期処理
   */
  private init() {
    const messageError = JSON.parse(
      SessionStorageService.getItem(CommonConstants.MESSAGE_ERROR)
    )
    if (messageError) {
      Store.setResponseErrors(messageError)
    }
  }
}
